import React, { Fragment } from "react";
import { Listbox, Transition } from "@headlessui/react";
import { SelectorIcon } from "@heroicons/react/solid";

const Filter = ({ selected, setSelected, options, msgSelect, width }) => {
  return (
    <Listbox value={selected} onChange={setSelected}>
      <div
        className={`relative text-gray-600 ${width ? width : "md:w-32 w-full"}`}
      >
        <Listbox.Button className="w-full border px-3 py-2 flex items-center justify-between">
          <span>{selected ? selected : msgSelect}</span>
          <SelectorIcon className="w-5 h-5 text-gray-400" />
        </Listbox.Button>
        <Transition
          as={Fragment}
          enter="transition ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="transition ease-in duration-150"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <Listbox.Options className="w-full absolute md:top-14 top-12 left-0 bg-white border z-20">
            {options.map((option, index) => (
              <Listbox.Option
                key={index}
                value={option}
                className={({ active, selected }) =>
                  `px-3 py-1 ${active ? "bg-blue-100" : ""} ${
                    selected ? "bg-blue-200" : ""
                  }`
                }
              >
                <span>{option}</span>
              </Listbox.Option>
            ))}
          </Listbox.Options>
        </Transition>
      </div>
    </Listbox>
  );
};

export default Filter;
